import React from "react";
import ReactDOM from "react-dom/client";
import App from './app';
import { store } from './redux/store'
import { Provider } from 'react-redux'

const el = document.getElementById('models-comparator-root');
const locale = el.getAttribute('data-locale');
const root = ReactDOM.createRoot(el);
const contact = root._internalRoot.containerInfo.dataset.contact;
const quotation = root._internalRoot.containerInfo.dataset.quotation;
const testDrive = root._internalRoot.containerInfo.dataset.testDrive;

if (root) {
    root.render(
        <Provider store={store}>
            <App contact={contact} locale={locale} quotation={quotation} testDrive={testDrive} />
        </Provider>
    );
}